"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataProcessDtoToJSON = exports.DataProcessDtoFromJSONTyped = exports.DataProcessDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function DataProcessDtoFromJSON(json) {
    return DataProcessDtoFromJSONTyped(json, false);
}
exports.DataProcessDtoFromJSON = DataProcessDtoFromJSON;
function DataProcessDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dataInizio': !runtime_1.exists(json, 'dataInizio') ? undefined : (json['dataInizio'] === null ? null : new Date(json['dataInizio'])),
        'dataFine': !runtime_1.exists(json, 'dataFine') ? undefined : (json['dataFine'] === null ? null : new Date(json['dataFine'])),
        'statocertificazione': !runtime_1.exists(json, 'statocertificazione') ? undefined : _1.StatoCertificazioneTypeFromJSON(json['statocertificazione']),
        'modalitacertificazione': !runtime_1.exists(json, 'modalitacertificazione') ? undefined : _1.ModalitaCertificazioneTypeFromJSON(json['modalitacertificazione']),
        'ndg': !runtime_1.exists(json, 'ndg') ? undefined : json['ndg'],
        'nominativo': !runtime_1.exists(json, 'nominativo') ? undefined : json['nominativo'],
        'filialeNdg': !runtime_1.exists(json, 'filialeNdg') ? undefined : json['filialeNdg'],
        'certificazioniFromLotto': !runtime_1.exists(json, 'certificazioniFromLotto') ? undefined : json['certificazioniFromLotto'],
        'pageSize': !runtime_1.exists(json, 'pageSize') ? undefined : json['pageSize'],
        'pageNumber': !runtime_1.exists(json, 'pageNumber') ? undefined : json['pageNumber'],
        'workflowId': !runtime_1.exists(json, 'workflowId') ? undefined : json['workflowId'],
    };
}
exports.DataProcessDtoFromJSONTyped = DataProcessDtoFromJSONTyped;
function DataProcessDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dataInizio': value.dataInizio === undefined ? undefined : (value.dataInizio === null ? null : value.dataInizio.toISOString()),
        'dataFine': value.dataFine === undefined ? undefined : (value.dataFine === null ? null : value.dataFine.toISOString()),
        'statocertificazione': _1.StatoCertificazioneTypeToJSON(value.statocertificazione),
        'modalitacertificazione': _1.ModalitaCertificazioneTypeToJSON(value.modalitacertificazione),
        'ndg': value.ndg,
        'nominativo': value.nominativo,
        'filialeNdg': value.filialeNdg,
        'certificazioniFromLotto': value.certificazioniFromLotto,
        'pageSize': value.pageSize,
        'pageNumber': value.pageNumber,
        'workflowId': value.workflowId,
    };
}
exports.DataProcessDtoToJSON = DataProcessDtoToJSON;
